import {
  BoundedContent,
  Row,
  Column,
  GridContainer,
  Box,
  Responsive,
  StyleSpaceWithAuto
} from '@vp/swan'
import React from 'react'
import { CategoryPageSectionType } from '../types/TemplateConfiguration'
import { useAppContext } from '../state/AppContext'
import { MARKETING_COLORS } from '@vp/marketing-colors'

const PageSectionWrapper = (props: {
  type?: CategoryPageSectionType
  marginBottom?: Responsive<StyleSpaceWithAuto> | undefined
  children: any
}) => {
  const { type, children, marginBottom } = props
  const { sidebarEnabled, backgroundColor } = useAppContext()
  const isTemplateLane = type === 'template lane'

  if (type === 'anchor links') {
    return <>{children}</>
  }

  if (type === 'promo banner' || type === 'section header' || type === 'side by side hero') {
    return <Box mb={marginBottom}>{children}</Box>
  }

  const pageContent = (
    <Box
      marginBottom={marginBottom}
      style={{
        backgroundColor: isTemplateLane ? MARKETING_COLORS[backgroundColor]?.code : undefined
      }}
    >
      <GridContainer>
        <Row>
          <Column
            span={sidebarEnabled ? 9 : 12}
            offset={sidebarEnabled ? 3 : 0}
            offsetSm={0}
            spanSm={12}
          >
            {children}
          </Column>
        </Row>
      </GridContainer>
    </Box>
  )

  return isTemplateLane ? (
    <BoundedContent paddingX={0}>{pageContent}</BoundedContent>
  ) : (
    <BoundedContent>{pageContent}</BoundedContent>
  )
}

export default PageSectionWrapper
